import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { UserVerificationProvider } from '../../providers/user-verification/user-verification';

@Component({
  selector: 'place-reviews-summary',
  templateUrl: 'place-reviews-summary.html',
})
export class PlaceReviewsSummaryComponent {
  log = debug('app:PlaceReviewsSummaryComponent');
  @Input() place;
  @Input() hasReviews = false;
  @Output() openReviews = new EventEmitter();
  @Output() openSubmitReviewComponent = new EventEmitter();

  constructor(public userVerification: UserVerificationProvider) {}

  ngOnInit(): void {
    this.doesPlaceContainReviews();
  }

  emitOpenReviews() {
    this.openReviews.emit();
  }

  async emitOpenSubmitReviewComponent() {
    if (!(await this.userVerification.isVerified())) {
      return;
    }
    this.openSubmitReviewComponent.emit();
  }

  doesPlaceContainReviews() {
    this.log('place: ', this.place);
    if (
      _.get(this.place, 'reviews.positive') ||
      _.get(this.place, 'reviews.negative')
    ) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/place-reviews-summary/place-reviews-summary.ts